import React from 'react'
import InputField from './InputField'
import Checkbox from './Checkbox'
import ButtonSubmit from './ButtonSubmit'
import { onSuccess, onFail } from "../../../../components/UI/PopUp/withoutSms"
import useForm from "./hooks";
import './index.scss'

const FormDeposit = ({link, product}) => {

    const {
        state,
        changeName,
        changePhone,
        checkedName,
        checkedPhone,
        toggleRule,
        onSend,
      } = useForm(link, product)
    const { name, phone, fetch, success, fail, rule } = state

    return (
        <div className="order-form">
            <form id="form" onSubmit={e => {
                e.preventDefault()
                onSend()
            }}>
                <InputField 
                    title={'ПІБ'}
                    placeholder={'ПІБ'}
                    message={'Перевірте правильність вводу імені або прізвища'}
                    change={changeName}
                    checked={name.checked}
                    checkedFunc={checkedName}
                    value={name.value}
                    valid={name.valid}
                    full={true}
                />
                <InputField 
                    title={'Телефон'}
                    type={'phone'}
                    message={'Перевірте правильність вводу номеру телефона'}  
                    change={changePhone}
                    checked={phone.checked}
                    value={phone.value}
                    checkedFunc={checkedPhone}
                    valid={phone.valid}
                    full={true}
                />
                <Checkbox onClick={toggleRule} checked={rule} />
                <ButtonSubmit onClick={onSend} title={'Подати заявку'} />
                {success ? onSuccess() : null}
                {fail ? onFail() : null}
            </form>
        </div>
    )
}

export default FormDeposit;